import { Box, Card, CardContent, CardHeader, Typography } from "@mui/material"
import Rating from '@mui/material/Rating';
import Stack from '@mui/material/Stack';
import StoreIcon from '@mui/icons-material/Store';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
const bull = (
    <Box
        component="span"
        sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)' }}
    >
        •
    </Box>
);
const StoreCard = ({ store }) => {
    
    return (
        <Box >
            <Card variant="outlined" dir="rtl" sx={{ p: 2, width: '100%' }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>

                    <StoreIcon sx={{ mr: 2 }} color="primary" />
                    <Typography variant="h4" dir="rtl" overflow="hidden" whiteSpace="nowrap" textOverflow="ellipsis">

                        {store.name_ar}
                    </Typography>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', px: 1 }}>


                    <Typography gutterBottom color="text" sx={{ fontSize: 14 }}>
                        {store.order_stores_count}
                    </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <AttachMoneyIcon sx={{ mr: 2 }} size={10} fontSize="small" color="text" />
                    <Typography gutterBottom color="text" sx={{ fontSize: 14 }}>
                        {store.store_sales_total}
                    </Typography>
                </Box>
                <Stack spacing={1}>
                    <Rating name="half-rating-read" color="text" borderColor="text" value={store.average_rating || 2.5} defaultValue={2.5} precision={0.5} readOnly />
                </Stack>


            </Card>
        </Box>
    )
}

export default StoreCard